var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 8.2C5.52 -1.4 18.48 -1.4 22.8 8.2",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.0008C11.5274 13.0008 11.0593 12.9077 10.6225 12.7267C10.1858 12.5458 9.7889 12.2807 9.45461 11.9464C9.12032 11.6121 8.85514 11.2152 8.67423 10.7784C8.49331 10.3417 8.40019 9.87354 8.40019 9.40078C8.40019 8.92802 8.49331 8.45989 8.67423 8.02312C8.85514 7.58635 9.12032 7.18949 9.45461 6.8552C9.7889 6.52091 10.1858 6.25573 10.6225 6.07481C11.0593 5.8939 11.5274 5.80078 12.0002 5.80078C12.955 5.80078 13.8706 6.18007 14.5458 6.8552C15.2209 7.53033 15.6002 8.446 15.6002 9.40078C15.6002 10.3556 15.2209 11.2712 14.5458 11.9464C13.8706 12.6215 12.955 13.0008 12.0002 13.0008Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6260563187dac52ae9b8f450370247a7.svg";
export { ForwardRef as ReactComponent };